import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { Brand, Maybe, User } from "../../../../gql/__generated__/graphql";
import { GET_BRAND } from "../../../apis/lambda/GraphQL/Brand/queries";
import { GET_USER } from "../../../apis/lambda/GraphQL/User/queries";

// Manually define BrandQuery as codegen is failing
interface BrandQuery {
  __typename?: "Query";
  brand?: Maybe<Brand>;
}

export const useProfile = (id?: string) => {
  // GraphQL
  const [getUser, { data: userData, loading: userLoading }] =
    useLazyQuery(GET_USER);
  const [getBrand, { data: brandData, loading: brandLoading }] =
    useLazyQuery(GET_BRAND);

  const [profile, setProfile] = useState<User | null>(null);

  useEffect(() => {
    if (!id) {
      setProfile(null);
      return;
    }

    if (!id.includes("@")) {
      getBrand({ variables: { id: id } });
    } else if (id.includes("@")) {
      getUser({ variables: { email: id } });
    }
  }, [id, getUser, getBrand]);

  useEffect(() => {
    if (brandData?.brand) {
      const { brand } = brandData;
      const userFromBrand: User = {
        name: brand.name,
        email: "", // Not available in GET_BRAND
        userType: "BRAND_USER",
        description: brand.description,
        categories: brand.categories,
        imageUrl: brand.logo,
        rating: brand.rating,
        completedCollabs: brand.completedCollabs.toString(),
        createdAt: brand.createdAt,
        updatedAt: brand.updatedAt,
        validated: false, // Assuming false as it's not in Brand
        socialMedia: null,
        monthlyGMV: null,
        brandId: brand.id,
        tiktokData: null,
      };
      setProfile(userFromBrand);
    } else if (userData?.user) {
      setProfile(userData.user as User);
    } else {
      setProfile(null);
    }
  }, [userData, brandData]);

  const updateProfile = (updatedProfile: User) => {
    // In a real app, you would have a mutation here and update the cache
    setProfile(updatedProfile);
  };

  return {
    profile,
    loading: userLoading || brandLoading,
    updateProfile,
  };
};
